import * as React from 'react';

import CreativeApproval56 from './CreativeApproval56';

export const creativeApproval56 = () => <CreativeApproval56 />;

export default {
    title: 'Illustration|CreativeApproval56',
    component: CreativeApproval56,
    parameters: {
        notes: "`import CreativeApproval56 from 'box-ui-elements/es/illustration/CreativeApproval56';`",
    },
};
